export default __webpack_public_path__ + "static/media/search-location.ff6cf941.gif";